import * as ReactDOM from 'react-dom';
import InstantYoutube from './InstantYoutube';
import './index.css';

ReactDOM.render(
  InstantYoutube,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/index.tsx